import React from 'react'
import { BusinessViews } from '../component'
import DashboardLayout from '../layouts/DashboardLayout'

function PgDashboard() {
    return (
        <DashboardLayout>
            <BusinessViews/>
        </DashboardLayout>
    )
}

export default PgDashboard;
